import React from "react";

const SummeryConversionTable = ({ data }) => {
  const conversions = data.conversions ?? [];
  const operator = data.operator ?? {};
  const comments = data.comments ?? {};

  const performance = comments.total
    ? `${((data.sum.total / comments.total) * 100).toFixed(2)} %`
    : "N/A";

  return (
    <div className="operator-conversion-table-widget">
      <div className="heading-container">
        <h6 className="widget-title">
          summarized overview<span> - All Packages</span>
        </h6>
        <h6 className="widget-subtitle">{`${operator.name} (${operator.memberId})`}</h6>
      </div>
      <table>
        <thead>
          <tr>
            <th scope="col" colSpan={3}>
              conversions
            </th>
          </tr>
          <tr>
            <th scope="col">package</th>
            <th scope="col">total</th>
            <th scope="col">rate (%)</th>
          </tr>
        </thead>
        <tbody>
          {conversions.map((item, index) => {
            const backgroundIdx = index % 2;
            const rowBackground = `package-row-${backgroundIdx}`;
            return (
              <tr key={item.pricingTierId} className={`${rowBackground}`}>
                <td>{item.pricingTierId}</td>
                <td>{item.summery.total}</td>
                <td>{item.conversionRate}</td>
              </tr>
            );
          })}
          <tr className="sub-total-row">
            <td colSpan={2}>Total Convertions</td>
            <td>{data.sum.total}</td>
          </tr>
        </tbody>
      </table>
      {/* Comments */}
      <table>
        <thead>
          <tr>
            <th scope="col" colSpan={3}>
              Comments
            </th>
          </tr>
        </thead>
        <tbody>
          <tr className="package-row-0">
            <td colSpan={2}>New Ads</td>
            <td>{comments.new}</td>
          </tr>
          <tr className="package-row-1">
            <td colSpan={2}>Renewals</td>
            <td>{comments.renew}</td>
          </tr>
          <tr className="sub-total-row">
            <td colSpan={2}>Total</td>
            <td>{comments.total}</td>
          </tr>
          <tr>
            <td colSpan={3}>
              <hr></hr>
            </td>
          </tr>
          <tr className="row-yellow-900">
            <td colSpan={2}>Performance</td>
            <td>{performance}</td>
          </tr>
        </tbody>
      </table>
    </div>
  );
};

export default React.memo(SummeryConversionTable);
